/** 학생 수정 제한(`mathflat.teacher.student_manage.edit`)에서 항목별로 풀어 주는 예외 키. */
export const STUDENT_EDIT_EXEMPTION = {
  SCHOOL_TYPE: 'mathflat.teacher.student_manage.edit.school_type',
  GRADE: 'mathflat.teacher.student_manage.edit.grade',
} as const
